import { message } from 'ant-design-vue'
// 对象合并，只合并相同的key，删除其他的key
export const mergeObject = (target, data) => {
  Object.keys(target).forEach(item => {
    if (data[item]) {
      target[item] = data[item]
    }
  })
  return target
}
// 字数限制
export const wordLimit = (text, len, warning = null) => {
  if (
    window.localStorage.getItem('wordLimit') &&
    window.localStorage.getItem('wordLimit') === '1'
  )
    return text.substring(0, len)
  if (text.length > len) {
    message.warning(
      warning
        ? warning
        : `输入框，字符长度${len}个字符，输入限制为中英文、标点符号、特殊字符`
    )
    window.localStorage.setItem('wordLimit', '1')
    // 节流设置 默认刷新频率 3S/time
    setTimeout(() => window.localStorage.setItem('wordLimit', '0'), 3000)
  }
  return text.substring(0, len)
}

// cookie设置
export const setCookie = (name, value, option) => {
  option = option || {}
  if (value === null) {
    value = ''
    option.expires = -1
  }
  let a = ''
  if (
    option.expires &&
    (typeof option.expires === 'number' || option.expires.toUTCString)
  ) {
    let b
    if (typeof option.expires === 'number') {
      b = new Date()
      b.setTime(b.getTime() + option.expires * 24 * 60 * 60 * 1000)
    } else {
      b = option.expires
    }
    a = '; expires=' + b.toUTCString()
  }
  let g = '; path=' + (option.path || '/'),
    e = '; domain=' + (option.domain ? option.domain : 'kapeixi.cn'),
    f = option.secure ? '; secure=' : ''
  const cookieValue = [name, '=', encodeURIComponent(value), a, g, e, f].join(
    ''
  )
  document.cookie = cookieValue
}
export const getCookie = name => {
  let arr,
    reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
  arr = document.cookie.match(reg)
  return arr ? unescape(arr[2]) : null
}
export const removeCookie = name => {
  setCookie(name, null)
}
// const isChromium =
//   window.chrome !== null && typeof window.chrome !== 'undefined'
// export const isChrome = window.navigator.userAgent.indexOf('Chrome') > -1
// export const isFF = window.navigator.userAgent.indexOf('Firefox') > -1
// export const isSafri = window.navigator.userAgent.indexOf('Safari') > -1
// export const isEdg = window.navigator.userAgent.indexOf('Edg') > -1
// export const isGoogleChrome = isChromium && isChrome && !isFF && !isEdg
export const detectBrowser = () => {
  const userAgent = navigator.userAgent
  if (
    userAgent.indexOf('Chrome') !== -1 &&
    userAgent.indexOf('Safari') !== -1 &&
    userAgent.indexOf('Edg') === -1
  ) {
    return 'Google Chrome' // Chrome
  } else if (userAgent.indexOf('Firefox') !== -1) {
    return 'Mozilla Firefox' // Firefox
  } else if (
    userAgent.indexOf('Safari') !== -1 &&
    userAgent.indexOf('Chrome') === -1 &&
    userAgent.indexOf('Edge') === -1
  ) {
    return 'Apple Safari' // Safari
  } else if (userAgent.indexOf('Edg') !== -1) {
    return 'Microsoft Edge' // Edge
  } else {
    return 'Unknown browser' // 其他浏览器...（可根据自己需要确定是否新增其他浏览器的判断）
  }
}

export const getURLOrigin = url => {
  try {
    return new URL(url).origin
  } catch (e) {
    return ''
  }
}
